
//Componentes Generales
import React, { useEffect, useRef } from "react";
import Rutas from "./utils/Rutas/Rutas";

import './App.css';

//Contexto
import AuthState from "./context/authentication/authState";
import UsuariosState from "./context/usuarios/usuariosState";
import ProdutosState from "./context/productos/productsState";
import ControlState from "./context/control/controlState";
import ControlGLBState from "./context/controlGLB/controlGLBState";
import AgregarReqState from "./context/agregarReq/agregarReqState";
import GruposState from "./context/grupos/gruposState";
import ActivoState from "./context/activoContex/activoState";
import ActivoTypeState from "./context/activoTypeContex/activoTypeState";
import Nivel1State from "./context/nivel1Context/nivel1State.js";
import Nivel2State from "./context/nivel2Context/nivel2State";
import Nivel3State from "./context/nivel3Context/nivel3State";
import ProductosXactivoState from "./context/productosXactivoContex/productosXactivoState";
import SistemaState from "./context/sistemaContex/sistemaState";
import SubsistemaState from "./context/subsistemaContex/subsistemaState";
import TareaState from "./context/tareaContext/tareaState";
import PeligroState from "./context/peligroContext/peligroState";
import EppState from "./context/eppContext/eppState";
import HerramientaState from "./context/herramientaContext/herramientaState";
import EqpgState from "./context/eqpgContext/eqpgState";
import ProcedimientoState from "./context/procedimientoContext/procedimientoState";
import TareasXprocedimientoState from "./context/tareasXprocedimientoContext/tareasXprocedimientoState.js";
import DocumentoState from "./context/documentosContext/documentosState.js";
import CategoriasRRHHState from "./context/categoriasRRHHContext/categoriasRRHHState.js";
import LegajoState from "./context/legajoContext/legajoState.js";
import InformesState from "./context/informesContext/informesState.js";
import ChecklistState from "./context/checklistContext/checklistState.js";
import ControlesState from "./context/controlesContext/controlState.js";
import ProveedorState from "./context/proveedoresContext/proveedorState.js";
import TemplateProduccionState from "./context/templateProduccionContext/templateProduccionState.js";
import ActivosXreportsState from "./context/activosXreportsContext/activosXreportsState.js";

//Socket
import Socket from "./context/socket/socket";
import ConsumosState from "./context/consumosContext/consumosState.js";
import OpdState from "./context/opdContext/opdState.js";
import AtributosFichaTecState from "./context/atributosFichaTecContext/atributosFichaTecState.js";
import Nivel4State from "./context/nivel4Context/nivel4State.js";
import Nivel5State from "./context/nivel5Context/nivel5State.js";
import ReservasState from "./context/reservas/reservasState.js";
import BloqueosState from "./context/bloqueos/bloqueosState.js";
import BloqueadosReservaState from "./context/bloqueadosReserva/bloqueadosReservaState.js";
import { useLocation } from "react-router-dom";

function App() {

  const flagTab = useRef(false);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    
    const isMobile = /iphone|ipad|android/.test(userAgent);
  
    if (isMobile) {
      document.querySelector('meta[name="viewport"]').setAttribute(
        'content',
        'width=1024, initial-scale=0.5' // Adjust scale as needed
      );
    }
  }, []);

  useEffect(() => {

    const handleBeforeUnload = () => {
      let count = parseInt(localStorage.getItem("openTabs") || "0", 10) - 1;
      if (count <= 0) {
        // Only clear your session-like data
        localStorage.removeItem("openTabs");
        localStorage.removeItem("activosList");
        localStorage.removeItem("checklistReg");
        localStorage.removeItem("checklistsReg");
        localStorage.removeItem("documentosList");
        localStorage.removeItem("ordenesTrabajo");
        localStorage.removeItem("procsProgramados");
      } else {
        localStorage.setItem("openTabs", count.toString());
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    let count = Number(localStorage.getItem("openTabs") || "0");
    localStorage.setItem("openTabs", (count + 1).toString());
    flagTab.current = true;

    // Cleanup
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      handleBeforeUnload(); // Decrement if the app unmounts
    };
  }, []);

  return (
    <div className="App">
      <Socket>
        <AuthState>
          <ControlState>
            <ControlGLBState>
              <AgregarReqState>
                <GruposState>
                  <ActivoState>
                    <UsuariosState>
                      <BloqueadosReservaState>
                        <ProdutosState>
                        <ActivoTypeState>
                          <Nivel1State>
                            <Nivel2State>
                              <Nivel3State>
                                <Nivel4State>
                                  <Nivel5State>
                                    <ProductosXactivoState>
                                      <SistemaState>
                                        <SubsistemaState>
                                          <ProcedimientoState>
                                            <TareaState>
                                             <PeligroState>
                                              <EppState>
                                              <HerramientaState>
                                              <EqpgState>
                                              <TareasXprocedimientoState>
                                                <DocumentoState>
                                                  <CategoriasRRHHState>
                                                    <LegajoState>
                                                      <InformesState>
                                                        <ChecklistState>
                                                          <ControlesState>
                                                            <ConsumosState>
                                                              <OpdState>
                                                              <ProveedorState>
                                                                <TemplateProduccionState>
                                                                <AtributosFichaTecState>
                                                                  <ReservasState>
                                                                    <BloqueosState>
                                                                      <ActivosXreportsState>
                                                                        <Rutas/>
                                                                      </ActivosXreportsState>
                                                                    </BloqueosState>
                                                                  </ReservasState>
                                                                </AtributosFichaTecState>
                                                                </TemplateProduccionState>
                                                              </ProveedorState>
                                                              </OpdState>
                                                            </ConsumosState>
                                                          </ControlesState>
                                                        </ChecklistState>
                                                      </InformesState>
                                                    </LegajoState>
                                                  </CategoriasRRHHState>
                                                </DocumentoState>
                                              </TareasXprocedimientoState>
                                              </EqpgState>
                                              </HerramientaState>
                                              </EppState>
                                             </PeligroState>
                                            </TareaState>
                                          </ProcedimientoState>
                                        </SubsistemaState>
                                      </SistemaState> 
                                    </ProductosXactivoState>  
                                  </Nivel5State>
                                </Nivel4State>
                              </Nivel3State>
                            </Nivel2State>
                          </Nivel1State>
                        </ActivoTypeState>
                        </ProdutosState>
                      </BloqueadosReservaState>
                    </UsuariosState>
                  </ActivoState>
                </GruposState>
              </AgregarReqState>
            </ControlGLBState>
          </ControlState>
        </AuthState>
      </Socket>
    </div>
  );
}

export default App;
